import {
  ScheduleWeek as ScheduleWeekType,
  ScheduleDay as ScheduleDayType,
  Timings as TimingsType,
} from 'data/types/schedule';

export const normalizeTimings = (data: TimingsType) => ({
  timeStart: {
    hours: data.timeStart.hours,
    minutes: data.timeStart.minutes,
    timeZone: data.timeStart.timeZone || 'am',
  },
  timeEnd: {
    hours: data.timeEnd.hours,
    minutes: data.timeEnd.minutes,
    timeZone: data.timeEnd.timeZone || 'am',
  },
});

export type Timings = ReturnType<typeof normalizeTimings>;

export const normalizeScheduleDay = (data: ScheduleDayType) => ({
  timings: data.timings ? data.timings.map(normalizeTimings) : [],
  open: data.open,
});

export type ScheduleDay = ReturnType<typeof normalizeScheduleDay>;

export const normalizeScheduleWeek = (data: ScheduleWeekType) => ({
  monday: normalizeScheduleDay(data.monday),
  tuesday: normalizeScheduleDay(data.tuesday),
  wednesday: normalizeScheduleDay(data.wednesday),
  thursday: normalizeScheduleDay(data.thursday),
  friday: normalizeScheduleDay(data.friday),
  saturday: normalizeScheduleDay(data.saturday),
  sunday: normalizeScheduleDay(data.sunday),
});

export type ScheduleWeek = ReturnType<typeof normalizeScheduleWeek>;
